import React, { useState } from 'react';
import { Link } from 'gatsby';
import { Checkbox, Form, Select, SubmitButton, TextInput } from '../HookForm';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { validationSchema } from './form.validator';
import activityOptions from './activityOptions';
import { states } from '../HookForm/selectOptions';
import OutboundLink from '../OutboundLink';
import sendForm from '../../utils/submitForm';

const ScheduleAVisitForm = () => {
  const [submitFailed, setSubmitFailed] = useState(false);
  //register resolver to useForm hook
  const { handleSubmit, register, formState } = useForm({
    resolver: yupResolver(validationSchema),
    // mode: 'onChange',
  });

  const submitForm = (data) => {
    return sendForm('schedulevisit', {
      educator_name: data.educator_name,
      school_club_name: data.school_club_name,
      email: data.email,
      phone: data.phone,
      grade_level_of_students: data.grade_level,
      street_address: data.school_club_address.address,
      city: data.school_club_address.city,
      state: data.school_club_address.state_province,
      zip: data.school_club_address.postal_code,
      availability: data.availability,
      activity: data.activity_type,
      additional_comments_: data.additional_comments,
      opt_in_: data.opt_in,
    }).catch((e) => {
      console.error(e);
      setSubmitFailed(true);
    });
  };

  const renderSuccess = () => {
    return (
      <p>
        Thank you for requesting a visit from a volunteer! Someone from the
        Discover Data program will be in touch with you soon.
      </p>
    );
  };

  const renderForm = () => {
    return (
      <Form onSubmit={handleSubmit(submitForm)}>
        <i className="pt-1 pb-2">
          Currently only available in the United States.
        </i>
        <TextInput
          type="text"
          label="Educator Name"
          name="educator_name"
          required
          register={register}
          error={formState.errors.educator_name?.message}
        />
        <TextInput
          type="text"
          label="School/Club Name"
          name="school_club_name"
          required
          register={register}
          error={formState.errors.school_club_name?.message}
        />
        <TextInput
          type="text"
          label="Address"
          name="school_club_address[address]"
          required
          register={register}
          error={formState.errors.school_club_address?.address?.message}
        />
        <TextInput
          type="text"
          label="City/Town"
          name="school_club_address[city]"
          required
          register={register}
          error={formState.errors.school_club_address?.city?.message}
        />
        <Select
          label="State/Province"
          name="school_club_address[state_province]"
          required
          placeholder="- Select -"
          options={{
            ...states,
          }}
          register={register}
          error={formState.errors.school_club_address?.state_province?.message}
        />
        <TextInput
          type="text"
          label="ZIP Code"
          name="school_club_address[postal_code]"
          required
          register={register}
          error={formState.errors.school_club_address?.postal_code?.message}
        />
        <TextInput
          type="text"
          label="Grade Level of Students"
          name="grade_level"
          required
          register={register}
          error={formState.errors.grade_level?.message}
        />
        <TextInput
          type="text"
          label="Email"
          name="email"
          required
          register={register}
          error={formState.errors.email?.message}
        />
        <TextInput
          type="text"
          label="Phone"
          name="phone"
          required
          register={register}
          error={formState.errors.phone?.message}
        />
        <Select
          label="Activity Selector"
          name="activity_type"
          required
          placeholder="- Select Activity -"
          options={activityOptions}
          register={register}
          error={formState.errors.activity_type?.message}
        />
        <TextInput
          type="text"
          label="Please let us know the days/time-windows that would work best for a visit."
          name="availability"
          required
          register={register}
          error={formState.errors.availability?.message}
        />
        <TextInput
          type="text"
          label="Additional Comments"
          name="additional_comments"
          register={register}
          error={formState.errors.additional_comments?.message}
        />
        <Checkbox
          label={
            <>
              By signing-up and clicking this box, you agree to Discovery
              Education’s{' '}
              <OutboundLink to="https://www.discoveryeducation.com/privacy-policy/">
                Privacy Policy
              </OutboundLink>{' '}
              and to the Nielsen Foundation’s{' '}
              <Link to="/discover-data-privacy">Privacy Policy</Link>. Both
              entities may contact you as described in their policies.
            </>
          }
          name="opt_in"
          required
          register={register}
          error={formState.errors.opt_in?.message}
        />
        <SubmitButton>Submit</SubmitButton>
        {formState.isSubmitted && !formState.isValid && (
          <p style={{ color: '#bc2121' }}>
            <small>One or more fields have an invalid value.</small>
          </p>
        )}
      </Form>
    );
  };

  const renderSubmitFailed = () => (
    <>
      <p style={{ color: '#801300' }}>
        There was an error processing this form, please try again later.
      </p>
    </>
  );

  return (
    <div className="schedule-a-visit">
      <div className="classroom-form">
        <h2>Virtually connect your class with a data expert</h2>
        {submitFailed
          ? renderSubmitFailed()
          : formState.isSubmitSuccessful
          ? renderSuccess()
          : renderForm()}
      </div>
    </div>
  );
};

export default ScheduleAVisitForm;
